import React, { useState } from "react";
import styling from "./Navbar.module.css";
import { FiMenu, FiBell } from "react-icons/fi";
import { BiCaretDown } from "react-icons/bi";
import { useSelector } from "react-redux";
import { AiOutlinePoweroff } from "react-icons/ai";
import firebase from "../../../firebase/firebase";
import userImage from "../../../assets/user.svg";
import { Link } from "react-router-dom";
import { RiArrowRightSLine } from "react-icons/ri";
import { BsGraphUp } from "react-icons/bs";
import { ImCross } from "react-icons/im";
import { MdClose } from "react-icons/md";

function Navbar({ toggleSidebar, guestUser, showSidebar }) {
  let user = useSelector((state) => state.user);
  let [showInfo, setShowInfo] = useState(false);
  // const dispatch = useDispatch();

  let logoutfromGoogle = () => {
    firebase
      .auth()
      .signOut()
      .then(function () {
        window.location.reload();
        console.log("Sign Out SuccessFull");
      })
      .catch(function (error) {
        console.log("Sign Out Error");
      });
  };
  // console.log("user", user);
  return (
    <div className={styling.Navbar}>
      <div className={styling.leftSection}>
        {showSidebar && window.innerWidth < 780 ? (
          <MdClose className={styling.Menu} onClick={toggleSidebar} />
        ) : (
          <FiMenu className={styling.Menu} onClick={toggleSidebar} />
        )}
        {guestUser && window.innerWidth > 780 && (
          <Link to="/signin">
            <div className={styling.signinSection}>
              <div className={styling.button1}>Sign In</div>
              {/* Please sign in to view the full product experience */}
              Demo mode with sample data - sign in to view real store data.
            </div>
          </Link>
        )}
      </div>
      <div className={styling.logo}>
        <Link to="/" className={styling.logoLink}>
          <span className={styling.logoMark}>
            <BsGraphUp />
          </span>
          <span className={styling.logoText}>ShopManager</span>
        </Link>
      </div>
      {guestUser && window.innerWidth < 780 ? (
        <Link to="/signin" className={styling.button2Parent}>
          {/* <div className={styling.signinSection}> */}
          <div className={styling.button2}>Sign In</div>
          {/* </div> */}
        </Link>
      ) : (
        <div className={styling.Details}>
          {/* <FiBell className={styling.sideIcon} /> */}
          <div className={styling.userProfileDetails}>
            <div
              className={styling.userProfile}
              onClick={() => (!guestUser ? setShowInfo(!showInfo) : null)}
            >
              <img
                src={guestUser || !user.photo ? userImage : user.photo}
                alt={user.name || "user"}
                onError={(e) => {
                  e.currentTarget.src = userImage; // fallback image
                }}
              />
              {window.innerWidth > 780 && <p>{user.name}</p>}
              {!guestUser && <BiCaretDown className={styling.downArrow} />}
            </div>
            {showInfo ? (
              <div className={styling.userProfileInfo}>
                <div className={styling.userProfileInfoIcon}></div>
                <div className={styling.userProfileInfoInner}>
                  <p>{user.email}</p>
                  <p onClick={() => logoutfromGoogle()}>
                    <AiOutlinePoweroff /> Logout
                  </p>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
}

export default Navbar;
